import { z } from "zod";
import { canonicalJsonSchema } from "../protocol/canonicalize.js";
import { protocolVersionSchema } from "../protocol/identifiers.js";
import { railAdapterKindSchema } from "../surfaces/adapters.js";
export const universalAdapterDeliverySchema = z
    .object({
    protocolVersion: protocolVersionSchema,
    adapter: railAdapterKindSchema,
    contentType: z.string().min(1),
    headers: z.record(z.string()),
    payload: canonicalJsonSchema,
    receiptBytes: z.string().min(1),
    takesCustody: z.literal(false),
})
    .strict();
